import router from '@/router/index'
import store from "@/store/index";
const whiteList = ['login','conferenceEventDisplay','disablePrompt',"spreadCreativityTest"] //路由白名单

router.beforeEach((to, from, next) => {
    if (whiteList.includes(to.name)) {
        return next(); // 白名单内的路由直接放行
    }
    if (store.getters.token) {
        return next()
    }else{
        if (to.path.includes("login")) {
            next()
        } else {
            next({name:'login'})
        }
    }
})
